import formatNumber from 'common/formatNumber';

import locales from './compliancePropertiesLocales';

export const incomeRangeChoices = [
  {
    label: `${formatNumber(0)} - ${formatNumber(18999)}`,
    value: '0-18',
  },
  {
    label: `${formatNumber(19000)} - ${formatNumber(23999)}`,
    value: '19-23',
  },
  {
    label: `${formatNumber(24000)} - ${formatNumber(27999)}`,
    value: '24-27',
  },
  {
    label: `${formatNumber(28000)} - ${formatNumber(35999)}`,
    value: '28-35',
  },
  {
    label: `${formatNumber(36000)} - ${formatNumber(56999)}`,
    value: '36-56',
  },
  {
    label: locales.annualIncomeMaxRange,
    value: '57-*',
  },
];

export const personalAssetsChoices = [
  {
    label: `${formatNumber(0)} - ${formatNumber(3000)}`,
    value: '0-2',
  },
  {
    label: `${formatNumber(3000)} - ${formatNumber(23000)}`,
    value: '3-22',
  },
  {
    label: `${formatNumber(23000)} - ${formatNumber(129000)}`,
    value: '23-128',
  },
  {
    label: `${formatNumber(129000)} - ${formatNumber(320000)}`,
    value: '129-319',
  },
  {
    label: `${formatNumber(320000)} - ${formatNumber(465000)}`,
    value: '320-464',
  },
  {
    label: locales.personalAssetsMaxRange,
    value: '465-',
  },
];
